import { create } from 'zustand';

type UseMeetingTemplateStore = {
  templateId: string;
  templateStatus: 'User' | 'Modified' | 'Default' | '';
  templateAction: 'Create' | 'Update';
};

const defaultValue: UseMeetingTemplateStore = {
  templateId: '',
  templateStatus: '',
  templateAction: 'Update',
};

const useMeetingTemplateStore = create<UseMeetingTemplateStore>(() => ({
  ...defaultValue,
}));

export const useGetTemplateId = () =>
  useMeetingTemplateStore((state) => state.templateId);
export const useGetTemplateAction = () =>
  useMeetingTemplateStore((state) => state.templateAction);

export const useGetTemplateStatus = () =>
  useMeetingTemplateStore((state) => state.templateStatus);

export const setTemplateId = (id: string) =>
  useMeetingTemplateStore.setState({
    templateId: id,
  });

export const setTemplateStatus = (
  status: UseMeetingTemplateStore['templateStatus'],
) =>
  useMeetingTemplateStore.setState({
    templateStatus: status,
  });

export const setTemplateAction = (
  action: UseMeetingTemplateStore['templateAction'],
) =>
  useMeetingTemplateStore.setState({
    templateAction: action,
  });

export const resetTemplateId = () =>
  useMeetingTemplateStore.setState({
    templateId: '',
  });

export const resetTemplate = () => {
  useMeetingTemplateStore.setState({
    ...defaultValue,
  });
};
